import NotFoundPage from "@/core/components/layout/NotFoundPage.vue";
import { RouterView, type RouteRecordRaw } from "vue-router";
import { t } from "@/core/i18n";

const QUESTIONS_API_URL = "v1.0/management/Questions";
const QUESTION_ANSWERS_API_URL = "v1.0/management/Questions/answers";

const route: RouteRecordRaw = {
  path: "/questions/",
  name: "questions",
  component: RouterView,
  meta: {
    breadcrumb: [{ title: t("app-questions"), routeName: "questions" }],
  },
  children: [
    {
      path: "",
      name: "Questions",
      component: () => import("./screens/questions/QuestionsList.vue"),
      meta: {
        breadcrumb: [{ title: t("app-questions"), routeName: "Questions" }],
      },
    },
    {
      path: "Create",
      name: "CreateQuestion",
      component: () => import("./screens/questions/QuestionForm.vue"),
      meta: {
        breadcrumb: [
          { title: t("app-questions"), routeName: "Questions" },
          { title: t("create-question"), routeName: "CreateQuestion" },
        ],
      },
    },
    {
      path: "Update/:id",
      name: "UpdateQuestion",
      component: () => import("./screens/questions/QuestionForm.vue"),
      meta: {
        breadcrumb: [
          { title: t("app-questions"), routeName: "Questions" },
          { title: t("update-question"), routeName: "UpdateQuestion" },
        ],
      },
    },
    {
      path: "Answers",
      name: "QuestionAnswers",
      component: () => import("./screens/answers/QuestionAnswers.vue"),
      meta: {
        breadcrumb: [
          { title: t("app-questions"), routeName: "Questions" },
          { title: t("question-answers"), routeName: "QuestionAnswers" },
        ],
      },
    },
    {
      path: ":catchAll(.*)",
      name: "Questions404",
      component: NotFoundPage,
    },
  ],
};

export { route, QUESTIONS_API_URL, QUESTION_ANSWERS_API_URL };
